// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/message/style/index.less
// module id = 1772
// module chunks = 0